import { render } from "./WorldClassAnalytics.vue?vue&type=template&id=513a3f42&scoped=true"
const script = {}

import "./WorldClassAnalytics.vue?vue&type=style&index=0&id=513a3f42&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513a3f42"]])

export default __exports__